import React from 'react';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { Badge } from '@/components/ui/badge';

interface TransactionsListThumbnailProps {
  isHovered?: boolean;
  alwaysVisible?: boolean;
}

export default function TransactionsListThumbnail({ 
  isHovered = false, 
  alwaysVisible = false 
}: TransactionsListThumbnailProps) {
  const baseScale = alwaysVisible ? 'scale-[0.4]' : 'scale-100';
  const hoverScale = isHovered ? 'scale-100' : baseScale;

  return (
    <div className={`transition-transform duration-300 origin-left ${hoverScale} ${isHovered ? 'z-50' : ''}`}>
      <Card className="w-[300px] shadow-sm">
        <CardHeader className="pb-3">
          <CardTitle className="text-sm font-medium">Transactions</CardTitle>
        </CardHeader>
        <CardContent>
          {/* Table Header */}
          <div className="grid grid-cols-5 gap-2 text-[10px] font-semibold text-muted-foreground pb-2 border-b">
            <div>Date</div>
            <div className="col-span-2">Description</div>
            <div>Category</div>
            <div className="text-right">Amount</div>
          </div>
          
          {/* Table Rows */}
          <div className="space-y-1 mt-2">
            <div className="grid grid-cols-5 gap-2 text-xs p-1.5 rounded hover:bg-muted/50">
              <div className="text-muted-foreground">15 Jan</div>
              <div className="col-span-2 font-medium">Acme Corp - Invoice #1234</div>
              <div>
                <Badge variant="secondary" className="text-[9px]">Sales</Badge>
              </div>
              <div className="text-right font-semibold text-green-600">+£12,500</div>
            </div>
            
            <div className="grid grid-cols-5 gap-2 text-xs p-1.5 rounded hover:bg-muted/50">
              <div className="text-muted-foreground">14 Jan</div>
              <div className="col-span-2 font-medium">Office Supplies Ltd</div>
              <div>
                <Badge variant="secondary" className="text-[9px]">Expenses</Badge>
              </div>
              <div className="text-right font-semibold text-red-600">-£850</div>
            </div>
            
            <div className="grid grid-cols-5 gap-2 text-xs p-1.5 rounded hover:bg-muted/50">
              <div className="text-muted-foreground">13 Jan</div>
              <div className="col-span-2 font-medium">Tech Solutions - Invoice #9012</div>
              <div>
                <Badge variant="secondary" className="text-[9px]">Sales</Badge>
              </div>
              <div className="text-right font-semibold text-green-600">+£8,200</div>
            </div>
            
            <div className="grid grid-cols-5 gap-2 text-xs p-1.5 rounded hover:bg-muted/50">
              <div className="text-muted-foreground">12 Jan</div>
              <div className="col-span-2 font-medium">Utilities Payment</div>
              <div>
                <Badge variant="secondary" className="text-[9px]">Utilities</Badge>
              </div>
              <div className="text-right font-semibold text-red-600">-£1,245</div>
            </div>
            
            <div className="grid grid-cols-5 gap-2 text-xs p-1.5 rounded hover:bg-muted/50">
              <div className="text-muted-foreground">11 Jan</div>
              <div className="col-span-2 font-medium">Client Payment - Project X</div>
              <div>
                <Badge variant="secondary" className="text-[9px]">Sales</Badge>
              </div>
              <div className="text-right font-semibold text-green-600">+£15,750</div>
            </div>
          </div>
        </CardContent>
      </Card>
    </div>
  );
}

export { TransactionsListThumbnail };
